import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithAuth } from '../baseQuery';

export type UserEmploymentHistory = Readonly<{
  id: number;
  user_id: number;
  employer_id?: number;
  employer_name?: string;
  employer_city?: string;
  employer_state?: string;
  job_title?: string;
  start_date?: string;
  end_date?: string;
  achievements?: string;
}>;

export type UserEmploymentHistoryRequest = Omit<
  UserEmploymentHistory,
  'id' | 'user_id' | 'created_at' | 'updated_at'
>;

export const userEmploymentHistoryApi = createApi({
  reducerPath: 'userEmploymentHistoryApi',
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getUserEmploymentHistory: builder.query<UserEmploymentHistory[], undefined>({
      query: () => ({
        url: '/user-employment-history',
        method: 'GET',
      }),
    }),

    getEmploymentHistoryById: builder.query<UserEmploymentHistory, number>({
      query: (id) => ({
        url: `/user-employment-history/${id}`,
        method: 'GET',
      }),
    }),

    createEmploymentHistory: builder.mutation<UserEmploymentHistory, UserEmploymentHistoryRequest>({
      query: (employmentHistoryData) => {
        return {
          url: '/user-employment-history',
          method: 'POST',
          body: {
            ...employmentHistoryData,
          },
        };
      },
    }),

    updateEmploymentHistory: builder.mutation<
      UserEmploymentHistory,
      { id: number; data: UserEmploymentHistoryRequest }
    >({
      query: ({ id, data }) => {
        return {
          url: `/user-employment-history/${id}`,
          method: 'PUT',
          body: {
            ...data,
          },
        };
      },
    }),

    deleteEmploymentHistory: builder.mutation<undefined, number>({
      query: (id) => ({
        url: `/user-employment-history/${id}`,
        method: 'DELETE',
      }),
    }),

    deleteAllEmploymentHistory: builder.mutation<{ message: string }, undefined>({
      query: () => ({
        url: '/user-employment-history',
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetUserEmploymentHistoryQuery,
  useGetEmploymentHistoryByIdQuery,
  useCreateEmploymentHistoryMutation,
  useUpdateEmploymentHistoryMutation,
  useDeleteEmploymentHistoryMutation,
  useDeleteAllEmploymentHistoryMutation,
} = userEmploymentHistoryApi;
